import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const CTAStats = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const statsData = labels.menuPages?.buyCar?.ctaSection?.stats || [];

  const statColors = [
    "text-emerald-400",
    "text-blue-400",
    "text-purple-400",
    "text-orange-400",
  ];

  const stats = statsData.map((stat: any, index: number) => ({
    value: stat.value || "",
    label: stat.label || "",
    description: stat.description || "",
    color: statColors[index] || statColors[0],
  }));

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 max-w-6xl mx-auto">
      {stats.map((stat, index) => (
        <div key={index} className="text-center space-y-3 md:space-y-4">
          <div className={`text-4xl md:text-5xl font-bold ${stat.color}`}>
            {stat.value}
          </div>
          <div className="text-white font-semibold text-base md:text-lg">
            {stat.label}
          </div>
          <div className="text-sm md:text-base text-gray-400 leading-relaxed px-2">
            {stat.description}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CTAStats;
